import type { ComponentType } from "react"
import { Globe, Instagram, Facebook } from "lucide-react"

// =====================================================
// BOOTH — social glyphs, in one place
// =====================================================
// Lucide has no X or TikTok mark, and its YouTube is an outline that reads
// wrong next to solid brand marks. So these three are hand-drawn.
//
// They used to be hand-drawn SEVENTEEN TIMES, across six files: the barber
// public profile, the barber profile editor, the booking storefront, the
// booking channels list, the shared social-links row, and help-share. Same
// path data, different default sizes, nothing tying them together — change the
// X mark and you would have to find all six, and whoever did it would miss one.
//
// Everything imports from here now. Paths are the Simple Icons marks.
// =====================================================

type IconProps = { className?: string }

export function TikTokIcon({ className = "w-5 h-5" }: IconProps) {
  return (
    <svg viewBox="0 0 24 24" fill="currentColor" className={className} aria-hidden="true">
      <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5.8 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1.84-.1z" />
    </svg>
  )
}

export function XIcon({ className = "w-5 h-5" }: IconProps) {
  return (
    <svg viewBox="0 0 24 24" fill="currentColor" className={className} aria-hidden="true">
      <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231L18.244 2.25Zm-1.161 17.52h1.833L7.084 4.126H5.117L17.083 19.77Z" />
    </svg>
  )
}

export function YouTubeIcon({ className = "w-5 h-5" }: IconProps) {
  return (
    <svg viewBox="0 0 24 24" fill="currentColor" className={className} aria-hidden="true">
      <path d="M22.54 6.42a2.78 2.78 0 0 0-1.94-2C18.88 4 12 4 12 4s-6.88 0-8.6.46a2.78 2.78 0 0 0-1.94 2A29 29 0 0 0 1 11.75a29 29 0 0 0 .46 5.33A2.78 2.78 0 0 0 3.4 19c1.72.46 8.6.46 8.6.46s6.88 0 8.6-.46a2.78 2.78 0 0 0 1.94-2 29 29 0 0 0 .46-5.25 29 29 0 0 0-.46-5.33ZM9.75 15.02V8.48l5.75 3.27-5.75 3.27Z" />
    </svg>
  )
}

/**
 * Label -> glyph, for every surface that lists socials: the storefronts render
 * these, Account Settings labels its inputs with them, and the profile editor
 * puts them inside its fields. One map means the field you edit always carries
 * the mark the page will show.
 */
export const SOCIAL_ICON: Record<string, ComponentType<IconProps>> = {
  Website: Globe,
  Instagram,
  TikTok: TikTokIcon,
  X: XIcon,
  Facebook,
  YouTube: YouTubeIcon,
}
